import React, { FC } from 'react';
import {
  useEnvironment,
  useExperiments,
  useTranslation,
} from '@wix/yoshi-flow-editor';
import { useSettings } from '@wix/tpa-settings/react';
import { TextButton } from 'wix-ui-tpa/cssVars';
import { useAddVisibilityClass } from '../../../../../hooks/useAddVisibilityClass';
import settingsParams from '../../../../../settingsParams';
import { classes, st } from './MoreInfoButton.st.css';
import { DataHooks } from './consts';

export interface MoreInfoButtonProps {
  onClick: () => void;
  url: string;
}

export const MoreInfoButton: FC<MoreInfoButtonProps> = ({ onClick, url }) => {
  const { isMobile } = useEnvironment();
  const settings = useSettings();
  const { t } = useTranslation();
  const { addVisibilityClass } = useAddVisibilityClass();
  const { experiments } = useExperiments();

  return (
    <TextButton
      onClick={
        experiments.enabled('specs.bookings.RenderServiceButtonsAsLinks')
          ? (e) => {
              e.stopPropagation();
              e.preventDefault();
              onClick();
            }
          : onClick
      }
      className={addVisibilityClass(
        st(classes.root, { isMobile }),
        classes.moreInfoButtonVisibility,
        'isMoreInfoButtonVisible',
      )}
      data-hook={DataHooks.ROOT}
      {...(experiments.enabled('specs.bookings.RenderServiceButtonsAsLinks')
        ? {
            as: 'a',
            href: url,
          }
        : undefined)}
    >
      {settings.get(settingsParams.moreInfoButtonText) ||
        t('info-card.design.more-info-label')}
    </TextButton>
  );
};
